<template lang="html">
    <section v-if="focusingClassAd" class="container mb-5 text-black-50">
        <div class="major-class d-flex card" style="margin-left:auto;margin-right:auto;width:100%;">
            <a class="major-class-url" href="focusingClassAd.AdUrl" style="">
                <img :class="[small?'major-class-img-sm':'major-class-img', 'card-img-top']" :src="focusingAdImg"
                     :alt="focusingClassAd.HosterName">
            </a>
            <div class="card-body text-left d-flex flex-column">
                <h5 class="card-title">{{focusingClassAd.Name}}</h5>
                <p class="major-class-desc card-text">{{focusingClassAd.Description}}</p>
                <div class="mt-auto mb-0 d-flex">
                    <p class="major-class-teacher card-text mb-0">授課老師： {{focusingClassAd.HosterName}}</p>
                    <button class="ml-auto mr-0 btn btn-primary"
                            v-on:click="gotoMore">
                        了解更多
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
    
<script>
    import Vue from 'vue'
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_OLD_SERVER_BASE_URL;    

    export default {
        props: {
            item: {
                type: Object,
                default: null,
            },
            tagLabel: {
                type: String,
                default: null
            },
            small: {
                type: Boolean,
                default: false,
            },
        },
        data: function() {
            return {
                focusingClassAd: null,
            };
        },
        methods: {
            gotoMore: function () {
                window.location.href = this.focusingClassAd.AdUrl;
            },
            loadFocusingClass: function () {
                Vue.axios.get('Speaking/GetFocusingClass')
                    .then(res => {
                        var data = res.data;
                        if (data.success) {
                            this.focusingClassAd = data.data;
                        } else if (data.success == false) {
                            this.$emit('load-date-failed', data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                            // 有 data / status / headers 參數可用
                            switch (error.response.status) {
                                case 401:
                                    alert('與伺服器的連線已過期或者您沒有存取的權限，請重新登入。');
                                    window.location.reload();
                                    return;

                                default:
                                    alert('發生嚴重的錯誤狀態, http status code: ' + error.response.status);
                                    return;
                            }
                        } else if (error.request) {
                            // 發送請求，但沒有接到回應
                            // error.request is an instance of XMLHttpRequest in the browser 
                            // and an instance of http.ClientRequest in node.js
                            console.log(error.request)
                        } else {
                            // 在設定 request 時出錯會進入此
                            console.log('Error', error.message)
                        }
                        this.$emit('load-date-failed', '無法取得本月主打資訊。發生不知名的錯誤');
                    });                
            },
        },
        mounted: function () {
            this.loadFocusingClass();
        },
        computed: {
            focusingAdImg: function () {
                if (this.focusingClassAd) {
                    var appUrl =  process.env.VUE_APP_OLD_SERVER_BASE_URL;
                    return appUrl + 'img/ad/' + this.focusingClassAd.AdImgFilename;
                }

                return null;
            },
        },
    };
</script>
    
<style lang="css">
    .major-class {
        flex-direction: column;
    }

    .major-class-url {
        width: 100%;
    }

    .major-class-desc {
        font-size: 0.8rem;
    }

    .major-class-teacher {
        font-size: 0.8rem;
    }

    /* lg */
    @media (min-width: 992px) {
        .major-class {
            flex-direction: row;
        }

        .major-class-url {
            width: unset;
        }

        .major-class-img {
            width: 550px;
        }

        .major-class-img-sm {
            width: 380px;
        }

        .major-class-desc {
            font-size: unset;
        }

        .major-class-teacher {
            font-size: unset;
        }
    }
</style>